import React, { useState, useEffect } from 'react';
import { MdClose, MdLocationOn, MdPeople, MdInfo, MdDateRange, MdPerson, MdPhone, MdEmail } from 'react-icons/md';
import axios from 'axios';
import { API_BASE_URL } from '../../config/api';

const ViewZoneModal = ({ isOpen, onClose, zone }) => {
  const [revenueOfficers, setRevenueOfficers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Get user data from localStorage
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');

  const config = {
    headers: {
      'Authorization': 'Basic ' + btoa('Techland:Techland@24'),
      'Content-Type': 'application/json',
    },
  };

  // Fetch revenue officers assigned to this zone
  const fetchZoneOfficers = async (zoneId) => {
    setLoading(true);
    try {
      const userMmdaId = userData.mmda_id || '';
      const apiUrl = `${API_BASE_URL}/revenue-officers?userRole=MMDA&mmda_id=${userMmdaId}&zone_id=${zoneId}`;
      console.log('Fetching officers for zone:', zoneId, 'API URL:', apiUrl);

      const response = await axios.get(apiUrl, config);
      console.log('API Response:', response.data);
      console.log('Officers found for zone', zoneId, ':', response.data.length);

      setRevenueOfficers(response.data);
    } catch (error) {
      console.error('Error fetching zone officers:', error);
      setRevenueOfficers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && zone && zone.zone_id) {
      fetchZoneOfficers(zone.zone_id);
    }
  }, [isOpen, zone]);

  if (!isOpen || !zone) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 24,
        width: '90%',
        maxWidth: 600,
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
          paddingBottom: 16,
          borderBottom: '1px solid #e0e0e0',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdLocationOn size={24} style={{ color: '#1976d2' }} />
            <h2 style={{ margin: 0, color: '#333', fontSize: 20 }}>Zone Details</h2>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 8,
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <MdClose size={24} style={{ color: '#666' }} />
          </button>
        </div>

        {/* Zone Information */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {/* Basic Info */}
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: 16,
            borderRadius: 8,
            border: '1px solid #e9ecef',
          }}>
            <h3 style={{ margin: '0 0 12px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
              <MdInfo size={20} style={{ color: '#1976d2' }} />
              Basic Information
            </h3>
            <div>
              <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Zone Name</label>
              <p style={{ margin: '4px 0 0 0', fontSize: 14, color: '#333' }}>{zone.zone_name}</p>
            </div>
            <div style={{ marginTop: 12 }}>
              <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Description</label>
              <p style={{ margin: '4px 0 0 0', fontSize: 14, color: '#333' }}>
                {zone.description || 'No description provided'}
              </p>
            </div>
          </div>

          {/* Status and Stats */}
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: 16,
            borderRadius: 8,
            border: '1px solid #e9ecef',
          }}>
            <h3 style={{ margin: '0 0 12px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
              <MdPeople size={20} style={{ color: '#1976d2' }} />
              Status & Statistics
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div>
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Status</label>
                <p style={{ margin: '4px 0 0 0', fontSize: 14 }}>
                  <span style={{
                    padding: '4px 8px',
                    borderRadius: 4,
                    fontSize: 12,
                    fontWeight: 'bold',
                    backgroundColor: zone.status === 'active' ? '#e8f5e8' : '#ffebee',
                    color: zone.status === 'active' ? '#2e7d32' : '#c62828'
                  }}>
                    {(zone.status || 'active').charAt(0).toUpperCase() + (zone.status || 'active').slice(1)}
                  </span>
                </p>
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Revenue Officers</label>
                <p style={{ margin: '4px 0 0 0', fontSize: 14, color: '#333' }}>
                  <span style={{
                    padding: '4px 8px',
                    backgroundColor: '#f5f5f5',
                    borderRadius: 4,
                    fontSize: 12,
                    color: '#666'
                  }}>
                    {zone.officer_count || 0} officers assigned
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* Assigned Revenue Officers */}
          <div style={{
            backgroundColor: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: 8,
            padding: 20,
            marginBottom: 20,
          }}>
            <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
              <MdPeople size={20} style={{ color: '#28a745' }} />
              Assigned Revenue Officers ({revenueOfficers.length})
            </h3>

            {loading ? (
              <div style={{ textAlign: 'center', padding: 20, color: '#666' }}>
                Loading officers...
              </div>
            ) : revenueOfficers.length > 0 ? (
              <div style={{ display: 'grid', gap: 12 }}>
                {revenueOfficers.map((officer, index) => (
                  <div key={officer.officer_id || index} style={{
                    backgroundColor: '#f8f9fa',
                    padding: 16,
                    borderRadius: 8,
                    border: '1px solid #e9ecef',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 16,
                  }}>
                    <div style={{
                      width: 50,
                      height: 50,
                      borderRadius: '50%',
                      backgroundColor: '#28a745',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      <MdPerson size={24} style={{ color: 'white' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <h4 style={{ margin: '0 0 4px 0', color: '#333', fontSize: 14, fontWeight: 'bold' }}>
                        {officer.full_name || `${officer.first_name} ${officer.last_name}`}
                      </h4>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: 12, color: '#666' }}>
                        {officer.phone && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <MdPhone size={12} />
                            <span>{officer.phone}</span>
                          </div>
                        )}
                        {officer.email && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <MdEmail size={12} />
                            <span>{officer.email}</span>
                          </div>
                        )}
                      </div>
                      {officer.group_name && (
                        <div style={{ marginTop: 4, fontSize: 11, color: '#28a745' }}>
                          Group: {officer.group_name}
                        </div>
                      )}
                    </div>
                    <div style={{
                      padding: '4px 8px',
                      backgroundColor: officer.status === 'active' ? '#e8f5e8' : '#ffebee',
                      borderRadius: 4,
                      fontSize: 11,
                      fontWeight: 'bold',
                      color: officer.status === 'active' ? '#2e7d32' : '#c62828'
                    }}>
                      {(officer.status || 'active').charAt(0).toUpperCase() + (officer.status || 'active').slice(1)}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{
                textAlign: 'center',
                padding: 40,
                color: '#666',
                backgroundColor: '#f8f9fa',
                borderRadius: 8,
                border: '2px dashed #dee2e6',
              }}>
                <MdPeople size={48} style={{ color: '#dee2e6', marginBottom: 12 }} />
                <p style={{ margin: 0, fontSize: 14 }}>No revenue officers assigned to this zone</p>
                <p style={{ margin: '4px 0 0 0', fontSize: 12 }}>Assign officers to start revenue collection activities</p>
              </div>
            )}
          </div>

          {/* MMDA Information */}
          <div style={{
            backgroundColor: '#e8f5e8',
            padding: 16,
            borderRadius: 8,
            border: '1px solid #c8e6c9',
          }}>
            <h3 style={{ margin: '0 0 8px 0', color: '#2e7d32', fontSize: 14, fontWeight: 'bold' }}>
              Regional Information
            </h3>
            <p style={{ margin: 0, fontSize: 12, color: '#2e7d32' }}>
              This zone is managed under your regional authority. You can assign revenue officers, 
              create groups, and monitor activities within this zone.
            </p>
          </div>
        </div>

        {/* Close Button */}
        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: 4,
              backgroundColor: '#1976d2',
              color: 'white',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 'bold',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewZoneModal;
